export const EMAIL_STATE = 'EMAIL_STATE';
export const CLEAR_EMAIL_STATE = 'CLEAR_EMAIL_STATE';

export const emailState = data => ({ type: EMAIL_STATE, data });
export const clearEmailState = () => ({ type: CLEAR_EMAIL_STATE });
